import { SeoModel } from './models';
import { createQuery } from '@/logic/libs';
import { long_term_cashing } from '@/constants/cashing';

const url = 'page-meta-data';

export const useGetPagesSeoMeta = createQuery<SeoModel, unknown>(
  {
    url: `${url}`,
    method: 'get',
  },
  {
    staleTime: long_term_cashing,
  }
);
